import type { DeepString } from "@/lib/i18n";

/**
 * WShopAdditionalSearchOptions - polskie tlumaczenia (Etap 3b).
 * Baseline z legacy `w_shop_additional_search_options_pl.lang` + `c_shop_category_pl.lang`.
 */
export const pl = {
  title: "Filtry",
  emptyContext: "Filtry dostępne tylko w kategorii sklepu.",
  sections: {
    query: "Wyszukaj",
    categorys: "Kategorie",
    producent: "Producent",
    variants: "Cechy",
    price: "Cena",
  },
  activeHeader: "Aktywne filtry",
  clearAll: "Wyczyść wszystko",
  removeChip: "Usuń filtr",
  queryPlaceholder: "Wpisz frazę...",
  priceFromLabel: "Od",
  priceToLabel: "Do",
  buttons: {
    apply: "Filtruj",
    cancel: "Anuluj",
  },
  emptyFacet: "Brak dostępnych opcji.",
} as const;

export type WShopAdditionalSearchOptionsTranslations = DeepString<typeof pl>;
